import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlPanelSvgComponent } from './control-panel.component';



@NgModule({
  declarations: [
    ControlPanelSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    ControlPanelSvgComponent
  ]
})
export class ControlPanelSvgModule { }
